import type { GetNotesInput, NoteCreateDto, NoteDto, NoteUpdateDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NoteService {
  apiName = 'Inventory';

  create = (input: NoteCreateDto) =>
    this.restService.request<any, NoteDto>({
      method: 'POST',
      url: '/api/inventory/notes',
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/notes/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, NoteDto>({
      method: 'GET',
      url: `/api/inventory/notes/${id}`,
    },
    { apiName: this.apiName });

  getList = (input: GetNotesInput) =>
    this.restService.request<any, PagedResultDto<NoteDto>>({
      method: 'GET',
      url: '/api/inventory/notes',
      params: { filterText: input.filterText, title: input.title, content: input.content, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  update = (id: string, input: NoteUpdateDto) =>
    this.restService.request<any, NoteDto>({
      method: 'PUT',
      url: `/api/inventory/notes/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
